// StreakCard — T-016 Part B. Surfaces computeStreak.

import type { JSX } from "react";
import { useI18n } from "../../i18n";

export interface StreakCardProps {
  /** Consecutive-day streak ending today or yesterday. */
  days: number;
}

export function StreakCard({ days }: StreakCardProps): JSX.Element {
  const { t } = useI18n();
  const n = Math.max(0, Math.floor(days));
  return (
    <div
      data-testid="streak-card"
      className="flex flex-col gap-2 border border-[var(--color-line)] bg-[var(--color-slab)] p-4"
      style={{ borderRadius: "var(--radius-card)", minWidth: 200 }}
    >
      <p className="font-subhead text-xs uppercase tracking-[0.06em] text-[var(--color-ink-mute)]">
        {t("analytics.streakLabel")}
      </p>
      <div className="flex items-baseline gap-2">
        <span
          className="font-numeric tabular text-[var(--color-rust)]"
          style={{ fontSize: 56, fontWeight: 700, lineHeight: 1 }}
        >
          {n}
        </span>
        <span className="font-subhead text-sm uppercase tracking-[0.06em] text-[var(--color-ink-mute)]">
          {t("analytics.dayStreak")}
        </span>
      </div>
    </div>
  );
}
